module.exports = __webpack_public_path__ + "6b707c61/img/scraper-icon.df6ccde5.svg";